import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function OrgTable({ isLoading, format, data, containerClassName }) {
  return (
    <div className={cn('w-full h-full ', containerClassName)}>
      {isLoading ? (
        <div className="grid  gap-3 p-3">
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
          <div className="col-span-2 animate-pulse bg-gray-200 h-8 w-full rounded" />
        </div>
      ) : (
        <table>
          <thead>
            <tr>
              {React.Children.toArray(
                format.map((col) => (
                  <th key={col?.id} scope="col" width={col.width || 'initial'}>
                    <span
                      className={cn(
                        'px-3 py-2 text-sm tracking-wide text-left text-gray-500 font-semibold uppercase',
                        col.labelClassName || '',
                      )}
                    >
                      {col.label}
                    </span>
                  </th>
                )),
              )}
            </tr>
          </thead>
          <tbody>
            {React.Children.toArray(
              data.map((row) => (
                <tr key={row?.id}>
                  {React.Children.toArray(
                    format.map((col) => {
                      const content = (() => {
                        if (typeof col.key === 'function') return col.key(row);
                        return row[col.key];
                      })();
                      return (
                        <td
                          key={col?.id}
                          className={cn(
                            'px-3 py-[0.6rem] text-gray-500 font-[500] text-[0.65rem] uppercase',
                            col.contentClassName || '',
                          )}
                          width={col.width || 'initial'}
                        >
                          {content}
                        </td>
                      );
                    }),
                  )}
                </tr>
              )),
            )}
          </tbody>
        </table>
      )}
    </div>
  );
}

OrgTable.defaultProps = {
  isLoading: false,
  containerClassName: '',
  data: [],
};

OrgTable.propTypes = {
  format: PropTypes.instanceOf(Array).isRequired,
  data: PropTypes.instanceOf(Array),
  isLoading: PropTypes.bool,
  containerClassName: PropTypes.string,
};

export default OrgTable;
